'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import flagHOC from '../components/FlagHOC';
import FluxContainer from 'flux/lib/FluxContainer';
import warning from './warning';

const DEPRECATION = 'Old binding style dataName="xxx" is deprecated! Use bound prop name with the remote data name as value: list="xxx". ';

//TODO as optimization we could use fluxcontainer only for multi store bindings. From flux doc: A FluxContainer is used to subscribe a react component to multiple stores.
const DataLinkContainer = {

    /**
     * Binds props to (RemoteData)Stores.
     * Set the props of the returning Component to the dataName.
     * (In future we may also support names of store methodes for non RemoteData Stores)
     *
     * 1. Style - Bind a prop to a store
     * link(BaseComponent, 'prop', store);
     *
     * 2. Style - Bind multiple props to one store
     * link(BaseComponent, ['prop1','prop2','prop3'], store);
     *
     * 3. Style - Bind multiple props to different stores
     * link(BaseComponent, { 'prop1': storeA ,'prop2': storeB ,'prop3': storeC });
     */
    link(Base, bindings, Store, noFlagHoc = false) {

        const baseName = Base.name;


        if (typeof bindings === 'string' || bindings instanceof String) {
            if (!Store) {
                throw new Error('Store expected');
            }
            bindings = { [ bindings ]: Store }
        }
        else if (Array.isArray(bindings)) {
            if (!Store) {
                throw new Error('Store expected');
            }
            bindings = bindings.reduce((b, prop) => {
                b[ prop ] = Store;
                return b;
            }, {})
        }

        const boundProps = Object.keys(bindings);

        const stores = boundProps.reduce((stores, prop) => {
            const store = bindings[ prop ];

            stores.indexOf(store) < 0 && stores.push(store);
            return stores;
        }, []);

        if (!noFlagHoc) {
            Base = flagHOC(Base, boundProps);
        }

        class RemoteDataLinkComponent extends React.Component {

            static getStores() {
                return stores;
            }

            static calculateState(prevState, props) {
                let newState;
                boundProps.forEach(prop => {
                    const current = prevState && prevState[ prop ],
                        store = bindings[ prop ];
                    let dataName = props[ prop ];

                    if (props.dataName) {
                        if (boundProps.length === 1) {
                            warning(false, DEPRECATION + ' > ' + baseName);
                            dataName = props.dataName;
                        } else {
                            throw new Error(DEPRECATION + ' > ' + baseName);
                        }
                    }
                    warning(dataName, 'No dataName for bound prop: ' + prop + ' found!');

                    const next = store.getRemoteData(dataName);

                    if (!next) {
                        //  console.warn('Linked Data \'' + dataName + '\' not initialized');
                    }

                    if (!current || current !== next) {
                        if (!newState) {
                            newState = { ...prevState };
                        }
                        newState[ prop ] = next;
                    }
                });

                return newState || prevState;
            }

            render() {
                return <Base {...this.props} {...this.state}/>;
            }

        }

        return FluxContainer.create(RemoteDataLinkComponent, { withProps: true });

    }


};

DataLinkContainer.propTypes = {
    dataName: PropTypes.string.isRequired
};

export default DataLinkContainer;



// WEBPACK FOOTER //
// ./js/utils/DataLinkContainer.jsx